import React, { useState, useEffect } from 'react';
import customCSS from './Allpayments.module.css';
import ENV from '../../constants/env-constants';
import { useLocation, useNavigate } from 'react-router-dom';
import ReactGA from "react-ga4";
import { Helmet } from 'react-helmet';
import { formatNumbers } from '../../utils/formatNumbers';

function Allpayments() {
  const [data, setTransactions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const location = useLocation()
  const navigate = useNavigate();
  // var data=[]
  function handleTransactionRowClick(userId) {
    if (typeof userId === 'string' && userId.includes('unregistered')) {
      alert('User not registered');
    } else navigate(`/admindashboard/usertransactions/${userId}`);
  }

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname, title: 'Admin All-Payments Page' });
    // Perform the API call
    fetch(`${ENV.API_URL}/api/transactions`, {
      method: 'GET', // It's a GET request
      headers: {
        'Content-Type': 'application/json'
      },
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      console.log(data)
      setTransactions(data); // Update the state with the fetched transactions
    })
    .catch(error => {
      console.error('Fetch error:', error);
    });
  }, []);

  // Calculate the current rows to display
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = data.slice(indexOfFirstRow, indexOfLastRow);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(data.length / rowsPerPage); i++) {
    pageNumbers.push(i);
  }

  return (
    <>
      <div className="layout-wrapper layout-content-navbar">
        <Helmet>
          <meta charSet="utf-8" />
          <title>All-Payments</title>
        </Helmet>
        <div className={`layout-container ${customCSS.maincontainer}`}>
          <h1 className={customCSS.heading}>All Payments</h1>

          <div className={customCSS.layoutWrapper}>
            <div className={customCSS.layoutContainer}>
              <div className={customCSS.tableWrapper}>
                <table className={customCSS.table}>
                  <thead>
                    <tr>
                      <th className={customCSS.th}>Transaction ID</th>
                      <th className={customCSS.th}>User ID</th>
                      <th className={customCSS.th}>First Name</th>
                      <th className={customCSS.th}>Last Name</th>
                      <th className={customCSS.th}>Amount Donated</th>
                      <th className={customCSS.th}>Frequency</th>
                      <th className={customCSS.th}>User Email</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentRows.map((item, index) => (
                      <tr className={customCSS.tr} onClick={()=>handleTransactionRowClick(item.userid)} key={index}>
                        <td className={customCSS.td}>{item.tid}</td>
                        <td className={customCSS.td}>{item.userid}</td>
                        <td className={customCSS.td}>{item.first_name || 'NA'}</td>
                        <td className={customCSS.td}>{item.last_name || 'NA'}</td>
                        <td className={customCSS.td}>{formatNumbers(item.amount)}</td>
                        <td className={customCSS.td}>{item.frequency || 'NA'}</td>
                        <td className={customCSS.td}>{item.email || item.useremail || 'NA'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              
              <div className={customCSS.pagination}>
                {pageNumbers.map(number => (
                  <button key={number} onClick={() => paginate(number)} className={customCSS.pageLink}>
                    {number}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Allpayments;
